import {
  BasketItem,
  BasketItemApplianceDetails,
  BasketItemQuoteDetails,
} from '@basket';
import { generateId } from '@common';
import { RegistrationApplianceDetails } from '../models/registration/registration-appliance-details.interface';

export function formatBasketItemApplianceDetailsToRegistrationApplianceDetails(
  basketItemApplianceDetails: BasketItemApplianceDetails,
  basketItemQuoteDetails: BasketItemQuoteDetails,
  basketItem: BasketItem,
  selectedAppliancePurchaseDate: Date,
): RegistrationApplianceDetails {
  const appliancePurchaseDate = new Date(selectedAppliancePurchaseDate);

  const registrationApplianceDetails: RegistrationApplianceDetails = {
    applianceCode: basketItemApplianceDetails.applianceCode,
    applianceName: basketItemApplianceDetails.applianceName,
    basketItemId: basketItem.itemId,
    basketQuoteId: basketItemQuoteDetails.quoteId,
    brandCode: basketItemApplianceDetails.brandCode,
    brandName: basketItemApplianceDetails.brandName,
    clientCode: basketItemApplianceDetails.clientCode,
    clientGroupCode: basketItemApplianceDetails.clientGroupCode,
    id: generateId(),
    modelNumber: basketItemApplianceDetails.modelNumber,
    purchaseDay: appliancePurchaseDate.getDate(),
    purchaseMonth: appliancePurchaseDate.getMonth() + 1,
    purchasePrice: basketItemApplianceDetails.purchasePrice,
    purchaseYear: appliancePurchaseDate.getFullYear(),
    serialNumber: basketItemApplianceDetails.serialNumber,
    warranty: Number(basketItemApplianceDetails.warranty),
  };
  return registrationApplianceDetails;
}
